import { render, staticRenderFns } from "./requestAddress.vue?vue&type=template&id=461e7d6d&scoped=true&"
import script from "./requestAddress.vue?vue&type=script&lang=js&"
export * from "./requestAddress.vue?vue&type=script&lang=js&"
import style0 from "./requestAddress.vue?vue&type=style&index=0&id=461e7d6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461e7d6d",
  null
  
)

export default component.exports